module.exports = __webpack_public_path__ + "static/media/10273092_846849762032019_5144619342151502578_o.a7256be6.jpg";